import {Injectable} from '@angular/core';
import {OutputsCommands} from '../models/outputs-commands';
import {OAuthService} from 'angular-oauth2-oidc';
import {PanelOutputsQueryResult} from '../models/panel-outputs-query-result.interface';
import {GraphQLClientService} from './graphql-client.service';

@Injectable({
  providedIn: 'root',
})
export class PanelOutputsService {
  constructor(private oAuthService: OAuthService, private graphQLClient: GraphQLClientService) {
  }

  async getUserPanelOutputs(userId: string): Promise<PanelOutputsQueryResult> {
    this.graphQLClient.setHeader('operatorId', '1');
    this.graphQLClient.setHeader('tenantId', 'DefaultEndpointsProtocol=https;AccountName=amichaistorage;AccountKey=EnatxoMmdc/AE3ym6JtU+R99UZvJqtI5++FTLD+MNtUgMMz+CLVcihM4P2ei141bFdV/Z1IlaMJ5Ryfvw2UZ0Q==;EndpointSuffix=core.windows.net');
    this.graphQLClient.setHeader('axtraxId', 'AxTrax1');
    const query = /* GraphQL */ `
      {
        outputs {
          id
          name
          panelId
          accessArea
          isLockdown
          status
          type
          groups {
            id
            description
          }
        }
      }
    `;
    return (await this.graphQLClient.requestAsync<PanelOutputsQueryResult>(query))?.data;
  }

  async closeOutputs(outputIdentifiers: string[]) {
    return await this.sendOpenCloseRquest(
      outputIdentifiers,
      OutputsCommands.CloseOutputs
    );
  }

  async openMomentOutputs(outputIdentifiers: string[]) {
    return await this.sendOpenCloseRquest(
      outputIdentifiers,
      OutputsCommands.OpenMomentOutputs
    );
  }

  async openPermanentOutputs(outputIdentifiers: string[]) {
    return await this.sendOpenCloseRquest(
      outputIdentifiers,
      OutputsCommands.OpenPermanentOutputs
    );
  }

  async sendOpenCloseRquest(outputIdentifiers: string[], queryType: string) {
    this.graphQLClient.setHeader('operatorId', '1');
    this.graphQLClient.setHeader('tenantId', '1');
    const variables = {
      command: {
        ids: outputIdentifiers,
      },
    };

    const query = `mutation($command: commandInput!){
      ${queryType}(command: $command)
    }`;
    return await this.graphQLClient.request(query, variables);
  }
}
